import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
export function Portfolio() {
  return <section className="py-16 md:py-24 relative" data-id="element-325">
      {/* Gradient transition from dark to site background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#050810] via-[#08061a] to-transparent pointer-events-none" data-id="element-326" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-327">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-328">
          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-white text-center leading-tight" data-id="element-329">
            Навчання побудоване на практиці{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-cyan-400 to-blue-500" data-id="element-330">
              ARMAR Solutions
            </span>
          </h2>
        </motion.div>

        {/* Logos Image */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="mb-12" data-id="element-331">
          <img src="https://cdn.magicpatterns.com/uploads/7SsYqd8nT3iBrQNeSB8nDJ/Group_1000005227.png" alt="Портфоліо клієнтів" className="w-full max-w-6xl mx-auto object-contain" data-id="element-332" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="text-center" data-id="element-333">
          <p className="text-gray-400 text-lg md:text-xl leading-relaxed" data-id="element-334">
            Управлінські та маркетингові рішення
            <br data-id="element-335" />
            <span className="text-blue-400" data-id="element-336">
              для компаній на різних етапах зростання
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}